import { useContext } from "react";
import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetTradeJumpInfoService } from "@/features/trade-jump/services/get-trade-jump-info-service";
import { GetTradeJumpInfoResponseModel } from "@/features/trade-jump/services/get-trade-jump-info-model";

export const useGetTradeJumpInfo = () => {
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);
  const getTradeJumpInfoService = new GetTradeJumpInfoService();

  // 明細ジャンプ情報取得
  const getTradeJumpInfo = async (
    passbookSid: string,
    detailSid: string,
    tableType: string
  ): Promise<GetTradeJumpInfoResponseModel | undefined> => {
    try {
      const res = await getTradeJumpInfoService.getTradeJumpInfo({
        passbook_sid: passbookSid,
        detail_sid: detailSid,
        table_type: tableType,
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("getTradeJumpInfo", error);
      throw error;
    } finally {
      //
    }
  };

  return {
    getTradeJumpInfo: errorHandledAsync(getTradeJumpInfo, setError),
  };
};
